<template>
<div class="chapter">
<div class="inner_page">
<div><a id="brief"></a></div>
<div class="margin"></div>
<div class="block1">
<div>
<h4 class="fronthead"><a href="#/html/003_toc#brief_">Barack Obama in Brief</a></h4>
<p class="line"><img alt="" height="10" src="html/docimages/line.jpg" width="350"/></p>
</div>
</div>
<p><span class="gray">BARACK OBAMA WAS</span> born in Hawaii on August 4, 1961, to Barack Obama, Sr., an economics student and devout Muslim from Kenya, and Ann Dunham, a white woman from Kansas.
  His parents separated when Barack was two years old and ultimately divorced. After the divorce his father attended Harvard University to pursue a doctorate before eventually returning to Kenya. His
  mother remarried and moved to Indonesia when Barack was six. The family lived in Jakarta for four years, and Barack returned to Hawaii by himself to live with his grandparents until he graduated
  from high school in 1979. He attended Occidental College in California for two years before he transferred to Columbia University.</p>
<p>In 1982, he received word that his father had died in a car accident in Kenya, and it threw him for a loop despite the fact that he had only seen his father once since his parents’
  divorce, when Barack was ten. He graduated from Columbia with a bachelor’s in political science in 1983. After spending a year in a corporate job, he moved to Chicago where he chose to work
  in community projects, joining a nonprofit organization involved in job training. In 1988, he enrolled at Harvard Law School, where he would first gain national recognition for serving as the first
  African-American president of the <em>Harvard Law Review</em>. After graduating <em>magna cum laude</em> from Harvard in 1991, Obama returned to Chicago to continue his work with community
  nonprofits as a civil rights lawyer and taught at the University of Chicago law school with a specialty in constitutional law. He met Michelle Robinson, another lawyer, in the summer of 1989 while
  they were working at a corporate law firm, and they married in 1992.</p>
<p>As a result of his visibility at Harvard, Random House asked him to write an autobiography, and <em>Dreams from My Father</em> was published in 1995. His mother, who had been diagnosed with
  cancer a few months earlier, died shortly after the book was published. He and Michelle have two daughters: Malia, born in 1999, and Sasha, born in 2001.</p>
<p>His first run at public office resulted in success when Barack won the election to represent the South Side of Chicago in the Illinois State Senate in 1996. He served until 2004, when he was
  elected to the U.S. Senate with 70 percent of the vote, becoming the fifth African-American in U.S. history to serve in the august chamber.</p>
<p>In the wake of his increasing national popularity, Barack recorded the audio version of his autobiography, <em>Dreams from My Father</em>, which won a Grammy Award for Best Spoken Word Album in
  2006. He formed an exploratory committee to decide whether to run for president in 2008, and announced that he would formalize his plans in February 2007. In November 2008 he was elected President
  of the United States.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_barak.vue?b086f686